import openvpn from "./openvpn.json";
import l2tp from "./l2tp.json";
import ikev2 from "./ikev2.json";
import shadowsocks from "./shadowsocks.json";
import vless from "./vless.json";

export default { openvpn, l2tp, ikev2, shadowsocks, vless };
